<script lang="ts">
  import Avatar from '$components/Avatar.svelte';
  import Price from '$components/Price.svelte';
  import { humanizeDurationMinutes, toFloat, toInteger } from '$lib/utils';
  import { ProgressiveImage } from '$mds/Image';

  export let guide: {
    id: string;
    objectID: string;
    slug: string;
    title: string;
    description: string;
    cover: string | null;
    seller_avatar: string;
    seller_name: string;
    game: string;
    game_logo: string | null;
    total_reading_time_minutes: number;
    chapter_count: number;
    published_at: string;
    last_updated_at: string;
    price: string;
  };
</script>

<article
  class="guide-card bg-ondark-medium ease-spring-out group relative flex min-h-full w-full scale-100 cursor-pointer flex-col justify-between overflow-hidden rounded-xl shadow-md shadow-transparent transition-all duration-700 hover:scale-105 hover:shadow-black/20"
  title={guide?.title}
>
  <a
    class="absolute left-0 top-0 z-[2] h-full w-full"
    href="/guides/view/{guide?.slug}"
    data-sveltekit-preload-code="hover"
    data-sveltekit-preload-data="off"
    title="View guide details"
  >
    <span class="sr-only">View guide details</span>
  </a>

  <div class="relative">
    <header class="aspect-video w-full overflow-hidden">
      <ProgressiveImage
        src={guide?.cover}
        sizes={{ xs: 200, sm: 360 }}
        class="aspect-video w-full scale-100 transform-gpu object-cover transition-transform !duration-300 group-hover:scale-105"
        fit="cover"
        aspect={16 / 9}
        alt={guide?.title || ''}
      />
    </header>
    {#if guide?.game}
      <div class="z-1 bg-ondark-low absolute bottom-2 right-2 flex w-fit items-center gap-1.5 rounded px-2 py-1">
        <ProgressiveImage
          src={guide?.game_logo}
          class="h-4 w-4 object-cover"
          sizes={{ xs: 24 }}
          fit="cover"
          rounded="rounded-full"
          alt={guide?.game || ''}
        />
        <span class="text-body-4xs text-ondark-primary">{guide?.game}</span>
      </div>
      <div class="z-1 absolute -bottom-4 left-4">
        <Avatar rounded="rounded-full" size="size-8" preview={guide?.seller_avatar} />
      </div>
    {/if}
    <div class="z-1 absolute -bottom-4 left-4">
      <Avatar rounded="rounded-full" size="size-8" preview={guide?.seller_avatar} />
    </div>
  </div>
  <div class="mt-4 min-h-full p-4">
    <div class="flex flex-col justify-between gap-2">
      <span class="text-ondark-primary text-body-lg highlight mb-auto line-clamp-2 text-start">
        {@html guide._formatted?.title ?? guide?.title ?? ''}
      </span>
      <div class="flex flex-wrap items-center justify-between">
        <span class=" highlight">
          {@html guide._formatted?.seller_name ?? guide?.seller_name ?? ''}
        </span>
        <div class="flex gap-1">
          <div class="text-ondark-primary text-body-4xs w-fit rounded bg-[#282834] px-2 py-1">
            {humanizeDurationMinutes(guide?.total_reading_time_minutes || 1, { shorter: true, removeSpace: true })}
          </div>
          <div class="text-ondark-primary text-body-4xs w-fit rounded bg-[#282834] px-2 py-1">
            <Price price={toFloat(guide?.price) || 0} allowFree short />
          </div>
        </div>
      </div>
    </div>
  </div>
</article>
